import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackChunkName: "ot-home" */ './views/home.vue'),
        meta: {
            title: 'Home',
            auth: undefined,
        }
    },
];

export default routes;